import type { GenericAbortSignal } from "axios";
import { createInfiniteQuery } from "react-query-kit";

import type { IInfiniteDoctorsParams, IInfiniteDoctorsResponse } from "./types";
import type { IAssignableDoctorsToMspParams } from "./path";

import { axiosClient } from "@/api";
import type { IWithInfinite } from "@api/types.ts";
import { getApi } from "@api/apiPath";

const { key, getPath } = getApi("infinite.getAllAssignableDoctorsToMsp");

type IResponse = IWithInfinite<IInfiniteDoctorsResponse>;
export type IAssignableDoctorsToMspVariables = IInfiniteDoctorsParams &
  IAssignableDoctorsToMspParams;
type IVariables = IAssignableDoctorsToMspVariables;

const getAllAssignableDoctorsToMsp = async (
  { mspId, ...props }: IVariables & { cursor: number },
  signal?: GenericAbortSignal,
): Promise<IResponse> => {
  const { data } = await axiosClient.get(getPath({ mspId }), {
    params: props,
    signal,
  });

  return data.data;
};

export const useGetAllInfiniteAssignableDoctorsToMsp = createInfiniteQuery<
  IResponse,
  IVariables
>({
  primaryKey: `infinite_${key}`,
  queryFn: ({ queryKey: [_primaryKey, variables], pageParam, signal }) =>
    getAllAssignableDoctorsToMsp({ ...variables, cursor: pageParam }, signal),
  getNextPageParam: (lastPage) => lastPage.nextCursor,
  //   initialPageParam: 1
});
